import {
  getSearchResult,
  getLoadedData,
  setSearch,
  setSearchedData,
  setRandomChart,
  setBarChartDetails,
  setBarChartValues
} from "./action";

const dispatchGetSearchResult = (dispatch) => (values) => {
  dispatch(getSearchResult(values));
};

const dispatchLoadSearchData = (dispatch) => (values) => {
  dispatch(getLoadedData(values));
};
const dispatchSearch = (dispatch) => (values) => {
  dispatch(setSearch(values));
};

const dispatchSearchedData = (dispatch) => (values) => {
  dispatch(setSearchedData(values))
}

const dispatchSetRandomChart = (dispatch) => (values) => {
  dispatch(setRandomChart(values))
}

const dispatchBarChartDetails = (dispatch) => (values) => {
  dispatch(setBarChartDetails(values))
}

const dispatchBarChartValues = (dispatch) => (values) => {
  dispatch(setBarChartValues(values))
}

const operation = {
  dispatchGetSearchResult,
  dispatchLoadSearchData,
  dispatchSearch,
  dispatchSearchedData,
  dispatchSetRandomChart,
  dispatchBarChartDetails,
  dispatchBarChartValues,
};

export default operation;
